<template>
  <v-card outlined class="breakdown-card mx-auto" max-width="360">
    <v-card-text class="pa-3">
      <div class="overline grey--text mb-1">Zusammensetzung</div>

      <div
        v-for="(part, i) in entry.breakdown"
        :key="i"
        class="d-flex align-center py-1"
      >
        <v-icon small class="mr-2" color="grey darken-1">
          {{ i === 0 ? 'mdi-flag-checkered' : 'mdi-dice-5-outline' }}
        </v-icon>
        <span class="flex-grow-1 text-truncate">{{ part.label }}</span>
        <v-chip
          x-small
          label
          :color="part.amount >= 0 ? 'green lighten-4' : 'red lighten-4'"
          :text-color="part.amount >= 0 ? 'green darken-3' : 'red darken-3'"
          class="font-weight-medium ml-2"
        >
          {{ part.amount >= 0 ? '+' : '' }}{{ part.amount.toLocaleString('de-DE') }}
        </v-chip>
      </div>

      <v-divider class="my-2"></v-divider>

      <div class="d-flex align-center">
        <span class="flex-grow-1 font-weight-bold">Gesamt</span>
        <v-chip
          small
          label
          :color="entry.amount >= 0 ? 'green' : 'red'"
          text-color="white"
          class="font-weight-bold ml-2"
        >
          {{ entry.amount >= 0 ? '+' : '' }}{{ entry.amount.toLocaleString('de-DE') }}
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PointCreditBreakdownList',
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.breakdown-card {
  background-color: rgba(0, 0, 0, 0.02);
}
</style>
